import React, {useEffect} from 'react'
import { Alphabet } from './../utils/constants';

const Encode = (props) => {
    const text = props.text.replace(/ /g, '>');
    const secretCode = props.secretCode.replace(/ /g, '_');
    const setCodedMessage = props.setCodedMessage;
    const numAlph = {};
    for(let i=0; i<Alphabet.length; i++) {
        numAlph[Alphabet[i]] = i;
    }

    let codedMessage = "";
    for(let i=0; i<text.length; i++) {
        codedMessage += Alphabet[(numAlph[text[i]] + numAlph[secretCode[i % secretCode.length]]) % Alphabet.length];
    }
   
    const randomN = Math.floor(text.length/4) + 1; 
    const randomM = Math.floor(secretCode.length/5) + 1; 
  
    codedMessage = codedMessage.slice(0, randomN) + ' ' + codedMessage.slice(randomN);
    codedMessage = codedMessage.slice(0, randomN + randomM) + ' ' + codedMessage.slice(randomN + randomM);
    codedMessage = codedMessage.slice(0, 2*randomN + randomM) + ' ' + codedMessage.slice(2*randomN + randomM);
    codedMessage = codedMessage.slice(0, 2*randomN + 2*randomM) + ' ' + codedMessage.slice(2*randomN + 2*randomM);
    useEffect(()=> {
        secretCode !== "" ? setCodedMessage(codedMessage) : setCodedMessage(props.text);
    }, [codedMessage])
    
    { return secretCode !== ""
        ?   <div className='updateInput' >{ secretCode.length > 9 
                ? codedMessage 
                : <span className="red">Encryption secret message should be longer than 9 characters</span>}
            </div>
        : <div className='updateInput' >{props.text}</div>
    }
}

export default Encode
